import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { gpedDetallesPedidoInterface } from "../interfaces/gpedDetallesPedido.inteface";

export async function DetallesPedidoAction(
    PedidoId: string
): Promise<ApiResponse<gpedDetallesPedidoInterface>> {
   const {data} = await apiClient.get(`gpedPedido/${PedidoId}/detalles`);
    return {
        status: 200,
        data,
        message: "Detalles de pedido obtenida correctamente",
    };
}